import fetcher from '@/core/lib/fetcher'
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { AddOn, AddOnsFormValues } from './addOns.types'
import { APIResponse } from '@/core/types/utils'

export const addOnsQueryOptions = (siteId: string, token: string) =>
  queryOptions({
    queryKey: ['addOns', siteId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(import.meta.env.VITE_API_BOOKING + `property/${siteId}/addons`)
        .json<Promise<APIResponse<AddOn[]>>>(),
  })

export const addOnByIdQueryOptions = (
  siteId: string,
  addonId: string,
  token: string
) =>
  queryOptions({
    queryKey: ['addOn', addonId, siteId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(
          import.meta.env.VITE_API_BOOKING +
            `property/${siteId}/addons/${addonId}`
        )
        .json<Promise<APIResponse<AddOn>>>(),
  })

export const useDeleteAddon = (token: string, siteId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      fetcher
        .auth(`Bearer ${token}`)
        .url(
          import.meta.env.VITE_API_BOOKING + `property/${siteId}/addons/${id}`
        )
        .delete()
        .json(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['addOns'],
      })
            void queryClient.invalidateQueries({
        queryKey: ['rates'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['rate'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['package'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['packages'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['activities'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['activity'],
      })
    },
  })
}
export const createAddOns = (
  addOn: AddOnsFormValues,
  siteId: string,
  token: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(import.meta.env.VITE_API_BOOKING + `property/${siteId}/addons`)
    .post(addOn)
    .json()

export const updateAddOn = (
  addOn: AddOnsFormValues,
  addonId: string,
  token: string,
  siteId: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(
      import.meta.env.VITE_API_BOOKING + `property/${siteId}/addons/${addonId}`
    )
    .put(addOn)
    .json()
